<template>
  <div class="tabs">
    <div :class="navWrapperClass">
      <ul class="nav nav-tabs" role="tablist">
        <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
          <button
            type="button"
            :class="['nav-link', tab.titleLinkClass, index === activeIndex && 'active']"
            role="tab"
            :aria-selected="index === activeIndex ? 'true' : 'false'"
            @click="select(index)"
          ><component :is="titleComponent(tab)"></component></button>
        </li>
      </ul>
    </div>
    <div :class="['tab-content', contentClass]"><slot></slot></div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, h, provide, reactive } from 'vue'
import { tabsContextKey, type TabRecord } from './tabs-context'
export default defineComponent({
  name: 'BTabs',
  props: {
    modelValue: { type: Number, default: undefined },
    value: { type: Number, default: undefined },
    navWrapperClass: { type: [String, Array, Object], default: '' },
    contentClass: { type: [String, Array, Object], default: '' }
  },
  emits: ['update:modelValue', 'input', 'activate-tab'],
  setup(props, { emit }) {
    const tabs = reactive<TabRecord[]>([])
    const activeIndex = computed(() => props.modelValue ?? props.value ?? 0)
    const select = (index: number) => {
      emit('update:modelValue', index)
      emit('input', index)
      emit('activate-tab', index)
    }
    provide(tabsContextKey, {
      activeIndex: () => activeIndex.value,
      indexOf: (id) => tabs.findIndex((tab) => tab.id === id),
      register: (tab) => tabs.push(tab),
      update: (id, tab) => {
        const index = tabs.findIndex((item) => item.id === id)
        if (index >= 0) Object.assign(tabs[index], tab)
      },
      unregister: (id) => {
        const index = tabs.findIndex((tab) => tab.id === id)
        if (index >= 0) tabs.splice(index, 1)
      }
    })
    const titleComponent = (tab: TabRecord) => ({ render: () => (tab.title ? tab.title() : h('span')) })
    return { tabs, activeIndex, select, titleComponent }
  }
})
</script>
